import { ProductGender, ProductSize } from '@onrunning/backstage-models';
import { FabricProducts } from './fabric-products.model';
import { ProductGroup } from './product-group.model';

export class ProductGroupFabricsProducts {
  public gender: ProductGender;
  public productGroup: ProductGroup;
  public fabricsProducts: FabricProducts[];
  public total: number;
  public collapsed: boolean;
  public sizes: ProductSize[];
}
